import { useEffect, useRef } from 'react';
import { MedicalServicesIcon } from '@ui/icons/material/MedicalServices';
import { SchoolIcon } from '@ui/icons/material/School';
import { CheckIcon } from '@ui/icons/material/Check';
import { StarIcon } from '@ui/icons/material/Star';
import { ApartmentIcon } from '@ui/icons/material/Apartment';
import '../styles/timeline.css';

interface TimelineEvent {
  year: number;
  title: string;
  description: string;
  side: 'left' | 'right';
  icon: React.ComponentType<{ size?: number; className?: string }>;
}

const events: TimelineEvent[] = [
  { year: 1979, title: 'Thành lập Khoa Y', description: 'Bắt đầu hành trình đào tạo nhân lực y tế', side: 'left', icon: MedicalServicesIcon },
  { year: 2002, title: 'Thành lập ĐHYDCT', description: 'Thành lập Trường Đại học Y Dược Cần Thơ, trực thuộc Bộ Y tế', side: 'right', icon: SchoolIcon },
  { year: 2017, title: 'Tự chủ', description: 'Thí điểm thực hiện cơ chế tự chủ đại học', side: 'left', icon: CheckIcon },
  { year: 2018, title: 'Kiểm định chất lượng', description: 'Đạt chuẩn kiểm định chất lượng cơ sở giáo dục', side: 'right', icon: StarIcon },
  { year: 2025, title: 'Phân hiệu An Giang', description: 'Chủ trương Quyết định Thành lập Phân hiệu Trường Đại học Y Dược Cần Thơ trên cơ sở Trường Cao đẳng Y tế Kiên Giang, tại tỉnh An Giang', side: 'left', icon: ApartmentIcon },
  { year: 2030, title: 'Trường trọng điểm quốc gia', description: 'Nâng cấp Trường trọng điểm Quốc gia', side: 'right', icon: StarIcon },
];

export default function Timeline() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const itemsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('visible');
            }, index * 150);
          }
        });
      },
      { threshold: 0.1 }
    );

    itemsRef.current.forEach((item) => {
      if (item) observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="timeline-section section" id="timeline" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title fade-up">Lịch sử phát triển</h2>

        <div className="timeline">
          <div className="timeline-line"></div>

          {events.map((event, index) => {
            const IconComponent = event.icon;
            return (
              <div
                key={event.year}
                className={`timeline-item timeline-${event.side}`}
                ref={(el) => (itemsRef.current[index] = el)}
              >
                <div className={`timeline-icon timeline-icon-${event.side}`}>
                  <IconComponent size={24} className="icon-inner" />
                </div>
                <div className="timeline-content">
                  <div className="timeline-year">{event.year}</div>
                  <h4>{event.title}</h4>
                  <p>{event.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}